module.exports = __webpack_public_path__ + "media/src/application/media/midural-c02bce976e7148e0875e64cce9b92da7.webp";